var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.559 15.733a3.65 3.65 0 0 1-1.833-.475c-1.3-.75-2.017-2.275-2.017-4.283V5.033c0-2.016.717-3.533 2.017-4.283S5.7.142 7.45 1.15l5.141 2.967c1.742 1.008 2.709 2.391 2.709 3.891s-.959 2.884-2.709 3.892l-5.141 2.967c-1.009.574-1.992.866-2.892.866m0-14.216q-.673-.002-1.208.308c-.9.517-1.392 1.658-1.392 3.208v5.934c0 1.55.492 2.683 1.392 3.208s2.133.375 3.475-.4l5.141-2.967c1.342-.775 2.084-1.766 2.084-2.808s-.742-2.033-2.084-2.808L6.826 2.225c-.817-.467-1.584-.708-2.267-.708"
  })));
};
export default SvgPlay;